import * as AffiliateCommission from "./AffiliateCommission";
import * as BillingAndPackage from "./BillingAndPackage";
import * as HolidaySetting from "./HolidaySetting";
import * as AppointmentListMEH from "react-lib/apps/MEH/sequence/AppointmentListMEH"
import * as ServiceCatalog from "./ServiceCatalog";
import * as SaveServiceOrder from "react-lib/apps/MEH/sequence/SaveServiceOrder"
import * as ScheduleSetting from "./ScheduleSetting";
import * as MakeAppointmentMeHey from "./MakeAppointmentMeHey";
import * as PaymentSummary from "./PaymentSummary"
import * as PaymentHistory from "./PaymentHistory"
import * as MeBillingI from "./MeBilling";
import * as MeChart from "./MeChart";
import * as MeScript from "./MeScript";
import * as MeReport from "./MeReport";
import * as PatientQueue from "./PatientQueue";
import * as MeReportList from "./MeReportList";
import * as AffiliateSettings from "./AffiliateSettings";
import * as SharedLabResult from "./SharedLabResult"
import * as Wellness from "./Wellness";
import * as WellnessOAAccessGrant from "./WellnessOAAccessGrant";
import * as WellnessEmployeeManagement from "./WellnessEmployeeManagement";


const SequencePattern: Record<string, Record<string, Record<string, any>>> = {
  BillingAndPackage: {
    default: {
      START: BillingAndPackage.Start,
      Action: BillingAndPackage.Action,
    },
  },
  HolidaySetting: {
    default: {
      START: HolidaySetting.Start,
      Action: HolidaySetting.Action,
    },
  },
  ScheduleSetting: {
    default: {
      START: ScheduleSetting.Start,
      Action: ScheduleSetting.Action,
    },
  },
  MakeAppointmentMeHey: {
    default: {
      START: MakeAppointmentMeHey.Start,
      Action: MakeAppointmentMeHey.Action,
    },
  },
  AppointmentListMEH: {
    default: {
      START: AppointmentListMEH.Start,
      Action: AppointmentListMEH.Action,
    },
  },
  ServiceCatalog: {
    default: { START: ServiceCatalog.Start, Action: ServiceCatalog.Action },
  },
  SaveServiceOrder: {
    default: {
      START: SaveServiceOrder.Start,
      Action: SaveServiceOrder.Action,
    }
  },
  MeBilling: {
    default: {
      START: MeBillingI.Start,
      Action: MeBillingI.Action,
    },
  },
  PaymentSummary: {
    default: {
      START: PaymentSummary.Start,
      Action: PaymentSummary.Action,
    },
  },
  PaymentHistory: {
    default: {
      START: PaymentHistory.Start,
      Action: PaymentHistory.Action,
    },
  },
  MeChart: {
    default: {
      START: MeChart.Start,
      Action: MeChart.Action,
    },
  },
  MeScript: {
    default: {
      START: MeScript.Start,
      Action: MeScript.Action,
    },
  },
  MeReport: {
    default: {
      START: MeReport.Start,
      Action: MeReport.Action,
    },
  },
  PatientQueue: {
    default: {
      START: PatientQueue.Start,
      Action: PatientQueue.Action,
    },
  },
  MeReportList: {
    default: {
      START: MeReportList.Start,
      Action: MeReportList.Action,
    },
  },
  AffiliateCommission: {
    default: {
      START: AffiliateCommission.Start,
      Action: AffiliateCommission.Action,
    },
  },
  AffiliateSettings: {
    default: {
      START: AffiliateSettings.Start,
      Action: AffiliateSettings.Action,
    },
  },
  SharedLabResult: {
    default: {
      START: SharedLabResult.Start,
      Action: SharedLabResult.Action,
    }
  },
  Wellness: {
    default: {
      START: Wellness.Start,
      Action: Wellness.Action,
    }
  },
  WellnessOAAccessGrant: {
    default: {
      START: WellnessOAAccessGrant.Start,
      Action: WellnessOAAccessGrant.Action,
    }
  },
  WellnessEmployeeManagement: {
    default: {
      START: WellnessEmployeeManagement.Start,
      Action: WellnessEmployeeManagement.Action,
    }
  },
}

export default SequencePattern;
